// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-0dd","content":"styles_content__3tkAz","tableWrap":"styles_tableWrap__2rxy6"};